import { getBrandName } from '../brand-name';
import { TENNISI_SOCIALS } from './constant';
import type { SocialIconsNames } from './type';

//TODO https://jira.tennisi.it/browse/SITE-599

export function getBrandSocials(): SocialIconsNames | null {
  const brandName = getBrandName();

  switch (brandName) {
    case 'tennisi':
      return TENNISI_SOCIALS;
    case 'chesnok':
      return null;
    case 'komyob':
      return null;
    default:
      assertExhaustiveness(brandName);
  }
}
